import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Hint from '../Hint';
import { pushFormFieldError } from '../../../forms/utils';

const InputField = ({
    styles,
    type,
    name,
    onBlur,
    onFocus,
    value,
    onChange,
    labelMessage,
    errors,
    textArea,
    disabled,
    hasError,
    notRequired,
    required,
    hint,
    formEventId,
}) => {
    React.useEffect(() => {
        if (hasError) {
            pushFormFieldError({ formId: formEventId, fieldId: name, errorMessage: errors });
        }
        // eslint-disable-next-line
    }, [errors]);

    return (
        <div className={styles.container}>
            {/* eslint-disable-next-line */}
            <label className={styles.label} htmlFor={name}>
                <span className={styles.labelText}>
                    <FormattedMessage id={labelMessage} />
                </span>
                {textArea ? (
                    <textarea
                        className={styles.input}
                        type={type}
                        name={name}
                        onBlur={onBlur}
                        onFocus={onFocus}
                        value={value}
                        onChange={onChange}
                        id={name}
                        disabled={disabled}
                    />
                ) : (
                    <input
                        className={styles.input}
                        type={type}
                        name={name}
                        onBlur={onBlur}
                        onFocus={onFocus}
                        value={value}
                        onChange={onChange}
                        id={name}
                        disabled={disabled}
                    />
                )}
                <div className={styles.border} />
            </label>
            {required && !hasError && <Hint id="inquiryPage.form.validation.required" />}
            {hint && !hasError && <Hint id={hint} />}
            {notRequired && !hasError && <Hint id="inquiryPage.form.validation.notRequired" />}
            {errors && (
                <span className={styles.errors}>
                    <FormattedMessage id={errors} />
                </span>
            )}
        </div>
    );
};

InputField.propTypes = {
    styles: PropTypes.shape().isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    labelMessage: PropTypes.string.isRequired,
    errors: PropTypes.string,
    hasError: PropTypes.bool,
    textArea: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    notRequired: PropTypes.bool,
    hint: PropTypes.string,
    formEventId: PropTypes.string,
};

InputField.defaultProps = {
    errors: null,
    textArea: false,
    hasError: false,
    disabled: false,
};

export default InputField;
